export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const YEARS = ['2026', '2025', '2024'];

export const LANGUAGES = ['Español', 'English', 'Português'];


export const PERIOD_MIN = '2024-01-01';
